(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('MessageController', MessageController);

  /* ngInject */
  function MessageController(config, Flash, messageService, $stateParams, $document, $window, formErrorsService, sessionService, Upload, $timeout, $state) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.message = getMessage();
    vm.newMessage = { body: '' };
    vm.addMessageToThread = addMessageToThread;
    vm.clearNewMessage = clearNewMessage;
    vm.deleteAttachment = deleteAttachment;
    vm.sessionService = sessionService;
    vm.config = config;
    vm.messageForm = {};
    vm.saving = false;

    $window.bsCustomFileInput.init();

    function clearNewMessage() {
      vm.newMessage = { body: '' };
      $window.history.back();
    }

    function addMessageToThread(newMessage) {
      vm.saving = true;

      let message = {
        author_id: vm.message.user_id,
        body: newMessage.body,
        message_thread_id: vm.message.id,
        urgent: newMessage.urgent || false
      };

      if (newMessage.attachments != null) {
        let uploadAttachments = Upload.upload({
          url: `${config.complianceServicesApiEndpoint}/api/message_threads/${vm.message.id}/messages`,
          method: 'POST',
          data: { message: message, attachments: newMessage.attachments },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        uploadAttachments.then(_response => {
          $timeout(() => {
            addMessageSuccess();
          });
        }, response => {
          addMessageFailure(response);
        });
      } else {
        messageService(sessionService.getAuthToken()).save({ id: vm.message.id }, message, addMessageSuccess, addMessageFailure);
      }
    }

    function addMessageSuccess() {
      vm.saving = false;
      $state.go('application.compliance_services.consultation');
      Flash.create('success', 'The reply was submitted');
    }

    function addMessageFailure(response) {
      vm.saving = false;
      vm.setFormErrors(vm.messageForm, response);
      Flash.create('danger', 'An error occurred with the submission. Please correct the form errors and resubmit.');
    }

    function getMessage() {
      let messageThread = messageService(sessionService.getAuthToken()).get({id: $stateParams.id});
      return messageThread;
    }

    function deleteAttachment(message, attachment, event) {              
      event.preventDefault();
      messageService(sessionService.getAuthToken()).deleteAttachment({id: $stateParams.id, message_id: message.id, attachment_id: attachment.id}, _deleteAttachmentSuccess, _deleteAttachmentFailure);
    }

    function _deleteAttachmentSuccess(response) {
      vm.message = response;
      Flash.create('success', 'The attachment was successfully deleted.');
    }

    function _deleteAttachmentFailure() {
      Flash.create('danger', 'An error occurred deleting the attachment. Please try again later.');
    }    
  }
})();
